import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './TransportEurope.css';

const TransportEurope: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['transport-europe'];

  return (
    <section className="transport" id="about">
      <Container fluid className="vh-100 d-flex flex-column align-items-center justify-content-center">
        <Row className="w-100 justify-content-center">
          <Col md={6} className="right-side d-flex justify-content-center align-items-center">
            <img src="/img/europa.png" alt="Europa" width={617} />
          </Col>
          <Col md={6} className="left-side d-flex flex-column justify-content-center align-items-center text-center">
            <h1 dangerouslySetInnerHTML={{ __html: t.title }} />
            <p>{t.description}</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TransportEurope;
